export default __webpack_public_path__ + "static/media/Dark.7e63cd44.svg";